import { useDispatch } from 'react-redux'
import { actions } from 'builder/modules/panel'
import { actions as userActions } from 'builder/modules/user'

import { useUser } from 'builder/hooks/useUser'

export const useDashV4Tour = () => {
  const user = useUser()
  const dispatch = useDispatch()
  const isTourCompleted = user?.uiStates?.dashv4TourCompleted

  const setTourStatus = (activate: boolean) => {
    if (isTourCompleted) return
    dispatch(actions.setUIStatesConfigStatus({ dashv4_tour_completed: activate }))
    dispatch(userActions.setUIUserState({ dashv4TourCompleted: activate }))
  }

  const scrollOnTopOnFinish = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return {
    run: !isTourCompleted,
    setTourStatus,
    scrollOnTopOnFinish,
  }
}
